module.exports = __webpack_public_path__ + "static/media/confirmIcon.071eb10e.png";